export default "__VITE_ASSET__Dhbi9cCU__"